import template from './booking.html';
import controller from './booking.controller';
import './booking.styl';

const bookingComponent = {
  template,
  controller,
  controllerAs: 'booking'
};

export default bookingComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/booking/booking.component.js
 **/